import React from 'react';

import { Link } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { Client } from '../../Client';
import logo from '../../../../public/assets/img/logo.svg';

import './TopBar.css';

class TopBar extends React.Component {
	
	render() {
		var homeLink = '/';
		if (Client.isLoggedIn()) homeLink = '/dashboard';

		return (
			<nav className="navbar navbar-toggleable-md navbar-inverse bg-inverse">
				<button className="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
					<span className="navbar-toggler-icon"></span>
				</button>
				<Link to={homeLink} className='navbar-brand'><img src={logo} style={{width: 90}} alt='MyMHP'/></Link>
				<div className="collapse navbar-collapse" id="navbarCollapse">
					{ Client.isLoggedIn() ? (					
					<ul className="navbar-nav mr-auto">
						<li className="nav-item">
							<Link className='nav-link' to='/advice'><i className="fa fa-info-circle"></i> Help & Advice</Link>
						</li>
						<li className="nav-item">
							<NavLink to={'/passport'} className='nav-link' activeClassName='active'><i className="fa fa-address-card"></i> My Passport</NavLink>
						</li>
						<li className="nav-item">
							<NavLink to={'/logout'} className='nav-link' activeClassName='active'><i className="fa fa-power-off"></i> Logout</NavLink>
						</li>
						<li className="nav-item">
							<a href="https://www.google.co.uk/" className='nav-link' activeClassName='active'><i className="fa fa-sign-out"></i> Quick Exit</a>
						</li>

					</ul>
					) : (
					<ul className="navbar-nav pull-right">
						<li className="nav-item">
							<Link className='nav-link' to='/advice'><i className="fa fa-info-circle"></i> Help & Advice</Link>
						</li>
						<li className="nav-item">
							<Link className='nav-link' to='/login'><i className="fa fa-address-card"></i> Create Passport</Link>
						</li>
					</ul>
					)}
				</div>
			</nav>
		);
	}
}




export default TopBar;



// WEBPACK FOOTER //
// ./src/js/components/TopBar/TopBar.js